/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { asyncScheduler, scheduled } from 'rxjs';
import { ReloadMap, ResetMapState } from '../../state/active-map.actions';
import { ClearSelection } from '../../state/selection.actions';
import { ResetMapConfigState } from '../../state/map-config.actions';
import { concatMapTo } from 'rxjs/operators';
import { Store } from '@ngxs/store';

export class ReloadCommand extends MapCommand {

    invoke() {
        const store: Store = this.deps['store'];
        scheduled([true], asyncScheduler).pipe(
            concatMapTo(store.dispatch(new ResetMapState())),
            concatMapTo(store.dispatch(new ResetMapConfigState())),
            concatMapTo(store.dispatch(new ClearSelection())),
        ).subscribe(() => store.dispatch(new ReloadMap()));
        this.deactivate$.next();
    }
}
